import {useEffect, useRef, useState} from "react"

import Grid from '@material-ui/core/Grid'

import Dialog from "@base/Dialog";
import {ButtonSave} from "@base/Button/ButtonForm"
import TextField from '@base/Inputs/Text/TextField'
import SelectOption from '@base/Inputs/Select/Select'
import EscolaService from '@services/EscolaService'
import VisualizadorDeArquivo from '@base/VisualizadorDeArquivo';
import CircularProgress from '@material-ui/core/CircularProgress'
import {dataMask} from '@helpers/MaskHelper'
import Toast from "@base/Toast";

import useStatusPendencia from '@hooks/enums/useStatusPendencia';
import useOrigemProblema from '@hooks/enums/useOrigemProblema';

export const TratamentoDataNascimentoDialog = (props) => {
  const processo = props.processo;

  const listagemStatus = useStatusPendencia();
  const listagemOrigemProblema = useOrigemProblema();
  
  const [, setFormId] = useState("");
  const [formTratamentoStatus, setFormTratamentoStatus] = useState("");
  const [formOrigemProblema, setFormOrigemProblema] = useState("");
  const [formOrigemProblemaOutro, setFormOrigemProblemaOutro] = useState("");
  const [formTratamentoEscola, setFormTratamentoEscola] = useState("");
  const [, setFormTratamentoCartaoId] = useState("");
  const [formTratamentoCartao, setFormTratamentoCartao] = useState("");
  const [formTratamentoDataNascimento, setFormTratamentoDataNascimento] = useState("");
  const [formTratamentoPendencia, setFormTratamentoPendencia] = useState("");
  const [blob, setBlob] = useState();
  const [loading, setLoading] = useState(false);
  const toastRef = useRef(null);

  const buttonsSubmit = () => !loading ? <ButtonSave onClick={tratarPendencia}/> : <><CircularProgress
    size={16}/> Aguarde...</>
  const isValido = (obj) => {

    let mensagem = "";

    if (obj === null || obj === undefined) {
      mensagem += `<li>O campo 'data de nascimento' é obrigatório.</li>`;
    } else if (obj.length < 10 && obj !== "@@") {
      mensagem += `<li>O campo 'data de nascimento' deve possuir formato DD/MM/AAAA ou @@.</li>`;
    }

    return {
      ok: mensagem === "",
      mensagem: `${mensagem}`
    }
  }

  const tratarPendencia = () => {
    setLoading(true);

    let obj = {
      status: formTratamentoStatus === "" ? undefined : formTratamentoStatus,
      dataNascimentoSubstituta: formTratamentoDataNascimento,
      origemProblema: formOrigemProblema === "" ? undefined : formOrigemProblema,
      descricaoOrigemOutro: formOrigemProblemaOutro === "" ? undefined : formOrigemProblemaOutro,
    };

    let valido = isValido(obj.dataNascimentoSubstituta);
    if (valido.ok) {
      EscolaService.atualizarStatusTratamentoDataNascimento(props.processo, props.id, obj).then(resultado => {
        props.handleSave(resultado);
        props.toastReference.current.show("success", "Data de Nascimento tratada com sucesso.");
        props.handleClose();
        setLoading(false);
      }).catch(error => {
        console.log(error)
        props.toastReference.current.show("error", "Erro" + error.response.data.mensagens.map(mensagem => mensagem).join(" ,"));
        setLoading(false);
      })
    } else {
      toastRef.current.show("warning", "Erro de validação! " + valido.mensagem);
      setLoading(false);
    }
    ;
  }

  const limparEstado = () => {
    setFormId("");
    setFormTratamentoStatus("");
    setFormTratamentoPendencia("");
    setFormTratamentoEscola("");
    setFormTratamentoCartao("");
    setFormTratamentoCartaoId("");
    setFormTratamentoDataNascimento("");
  }

  useEffect(() => {
    setFormId(props.id);
  }, [props.id]);

  useEffect(() => {
    if (props.id) {

      EscolaService.downloadArquivoCartao(processo, undefined, props.id).then(resposta => {
        setBlob(resposta.data);
      });

      EscolaService.buscaDadosDoCartao(processo, props.id).then(resposta => {

        let pendencia = resposta;

        if (pendencia.data.tratamentoDataNascimento) {
          setFormTratamentoStatus(pendencia.data.tratamentoDataNascimento.status);
          setFormTratamentoPendencia(pendencia.data.tratamentoDataNascimento.tipoLabel);
          setFormOrigemProblema(pendencia.data.tratamentoDataNascimento.origem);
          setFormOrigemProblemaOutro(pendencia.data.tratamentoDataNascimento.descricaoOrigemOutro);
        }
        setFormTratamentoEscola(pendencia.data.escola);
        setFormTratamentoCartao(pendencia.data.codigo);
        setFormTratamentoCartaoId(pendencia.data.id);
        setFormTratamentoDataNascimento(pendencia.data.dataNascimento);
      });


    }
  }, [processo, props.id, props.codigo]);

  return (
    <>
      <Toast ref={toastRef}/>
      <Dialog
        maxWidth={"lg"}
        fullWidth={true}
        closeDialog={() => {
          limparEstado();
          props.handleClose();
        }}
        openDialog={props.open}
        title="Tratar Data de Nascimento"
        actions={buttonsSubmit()}
      >

        <Grid container spacing={3}>
          <Grid item sm={4}>
            <Grid container spacing={3}>
              <Grid item sm={12}>
                <TextField disabled label="Escola" value={formTratamentoEscola}/>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item sm={12}>
                <TextField disabled label="Código do Cartão" value={formTratamentoCartao}/>
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item sm={12}>
                <TextField disabled label="Pendência" value={formTratamentoPendencia}/>
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              <Grid item sm={12}>
                <SelectOption
                  label='Status'
                  required
                  value={formTratamentoStatus}
                  name='formTratamentoStatus'
                  onChange={(e) => setFormTratamentoStatus(e.target.value)}
                  options={listagemStatus.data}
                />
              </Grid>
            </Grid>

            <Grid container spacing={3}>
              <Grid item sm={12}>
                <SelectOption
                  label='Origem do Problema'
                  required={formTratamentoStatus === 'RESOLVIDA'}
                  value={formOrigemProblema}
                  name='formOrigemProblema'
                  onChange={(e) => setFormOrigemProblema(e.target.value)}
                  options={listagemOrigemProblema.data}
                />
              </Grid>
            </Grid>
            <Grid container spacing={3}>
              {formOrigemProblema === "OUTRO" &&
                <Grid item sm={12}>
                  <TextField label="Qual foi o problema?" value={formOrigemProblemaOutro}
                             onChange={(e) => setFormOrigemProblemaOutro(e.target.value)}/>
                </Grid>
              }
            </Grid>

            <Grid container spacing={3}>
              <Grid item sm={12}>
                <TextField label="Data de Nascimento" value={formTratamentoDataNascimento}
                           required
                           autoComplete="off"
                           onChange={(e) => setFormTratamentoDataNascimento(dataMask(e.target.value))}/>
              </Grid>
            </Grid>
          </Grid>
          <Grid item sm={8}>
            {blob ? <VisualizadorDeArquivo

                blob={blob}
              />
              : <CircularProgress size={16}/>}
          </Grid>
        </Grid>

      </Dialog>
    </>
  );
}

export default TratamentoDataNascimentoDialog;
